import axios from '../../../axios';
import IOurEntity from '../types/IOurEntity';
import { IOurEntityBankForm } from '../types/IOurEntityBankForm';
import { IOurEntityLegalForm } from '../types/IOurEntityLegalForm';
import IOurEntitySignatoryForm from '../types/IOurEntitySignatoryForm';
import { OurEntityTaxation } from '../types/OurEntityTaxation';

const url = '/invoicingservice/api';

export const saveOurEntityTaxation = (ourEntityTaxation: OurEntityTaxation) =>
  axios.post(`${url}/our-entity-taxation`, ourEntityTaxation);

export const getOurEntityTaxationList = (ourEntityId: string) =>
  axios.get(`${url}/our-entity-taxation`, { params: { ourEntityId } });

export const saveOurEntity = (ourEntity: IOurEntity) =>
  axios.post(`${url}/our_entities/add`, ourEntity);
export const saveOurEntityLegal = (ourEntityLegalForm: IOurEntityLegalForm) =>
  axios.post(`${url}/our_entities/legal/add`, ourEntityLegalForm);
export const saveOurEntityBank = (ourEntityLegalBank: IOurEntityBankForm) =>
  axios.post(`${url}/our_entities/bank/add`, ourEntityLegalBank);

export const saveOurEntitySignatory = (ourEntitySignatoryForm: IOurEntitySignatoryForm) =>
  axios.post(`${url}/our_entities/signatory/add`, ourEntitySignatoryForm);

export const updateOurEntity = (ourEntity: IOurEntity, id: string) =>
  axios.put(`${url}/our_entities/${id}/edit`, ourEntity);

export const updateSignatory = (ourEntity: IOurEntity, id: string) =>
  axios.put(`${url}/our_entities/${id}/edit`, ourEntity);

export const getOurEntityById = (id: string) => axios.get(`${url}/our_entities/${id}`);

export const ourEntityList = (
  pageNo: number,
  pageSize: number,
  sortBy?: string,
  sortOrder?: string | null
) =>
  axios.get(
    `${url}/our_entities/list?pageNo=${pageNo}&pageSize=${pageSize}&sortBy=${sortBy}&sortOrder=${sortOrder}`
  );

export const ourEntityAllList = () => axios.get(`${url}/our_entities/all-list`);

export const ourEntityLegalIdentifierList = (id: string, pageNo: number, pageSize: number) =>
  axios.get(`${url}/our_entities/${id}/legal?pageNo=${pageNo}&pageSize=${pageSize}`);
export const ourEntityBankList = (id: string, pageNo: number, pageSize: number) =>
  axios.get(`${url}/our_entities/${id}/bank?pageNo=${pageNo}&pageSize=${pageSize}`);
export const ourEntitySignatoryList = (id: string, pageNo: number, pageSize: number) =>
  axios.get(`${url}/our_entities/${id}/signatory?pageNo=${pageNo}&pageSize=${pageSize}`);

export const deleteOurEntityLegal = (id: string) =>
  axios.delete(`${url}/our_entities/legal/${id}/delete`);

export const deleteOurEntityBank = (id: string) =>
  axios.delete(`${url}/our_entities/bank/${id}/delete`);

export const deleteOurEntitySignatory = (id: string) =>
  axios.delete(`${url}/our_entities/signatory/${id}/delete`);

export const findByIdOurEntityLegal = (id: string) => axios.get(`${url}/our_entities/legal/${id}`);

export const findByIdOurEntityBank = (id: string) => axios.get(`${url}/our_entities/bank/${id}`);

export const findByIdOurEntitySignatory = (id: string) =>
  axios.get(`${url}/our_entities/signatory/${id}`);
